import { INotificationOnClickResult, Notification } from "./notification";
import Vue from "vue";
import { AWSFileService } from "@/services";

export class AwsFileNotification extends Notification {
	public async onClick(vue: Vue): Promise<INotificationOnClickResult> {
		if (!this.Data) return {};
		if (!this.Data.ReportAwsFileToken) return {};
		await AWSFileService.downloadFile(this.Data.ReportAwsFileToken);
		return {};
	}

	public getIcon():string {
		return "file";
	}

	public getTone():string {
		return "info";
	}

	public getActionKey():string {
		return "download";
	}
}
